export default __webpack_public_path__ + "static/eclipse2-36dbf8ae12047c7c4d8e38489ac66f5d.png";